/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { QueryClientProvider } from 'react-query';
import { Provider, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { theme } from 'components/styles/theme';
import { store } from 'data';
import { TemplateObjectType } from 'data/templates/api';
import { removeConditionalVariables } from 'data/templates/projects/slices';
import { queryClient } from 'queries';
import translations from 'translations/en.json';

const RemoveVariable = ({
  variableId,
  templateType,
}: {
  variableId: any;
  templateType?: TemplateObjectType;
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line default-case
    switch (templateType) {
      case TemplateObjectType.Project:
        dispatch(
          removeConditionalVariables({
            variableId,
            templateType,
          }),
        );
    }
  }, [dispatch, templateType, variableId]);

  return null;
};

export const RemoveConditionalVariable = ({
  variableId,
  templateType,
}: {
  variableId: any;
  templateType?: TemplateObjectType;
}) => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <IntlProvider locale="en" messages={translations}>
          <QueryClientProvider client={queryClient}>
            <RemoveVariable
              variableId={variableId}
              templateType={templateType}
            />
          </QueryClientProvider>
        </IntlProvider>
      </ThemeProvider>
    </Provider>
  );
};
